import { application } from "./application";

import HelloController from "./hello_controller";
application.register("hello", HelloController);

import PasswordVisibilityController from "./password_visibility_controller";
application.register("password-visibility", PasswordVisibilityController);

import FieldValidatorController from "./field_validator_controller";
application.register("field-validator", FieldValidatorController);

import PasswordMatchController from "./password_match_controller";
application.register("password-match", PasswordMatchController);

import CrestPreviewController from "./crest_preview_controller";
application.register("crest-preview", CrestPreviewController);

import ShareController from "./share_controller";
application.register("share", ShareController);

import FlashController from "./flash_controller";
application.register("flash", FlashController);

import TabsController from "./tabs_controller";
application.register("tabs", TabsController);

import LiveClockController from "./live_clock_controller";
application.register("live-clock", LiveClockController);

import LiveReconnectController from "./live_reconnect_controller";
application.register("live-reconnect", LiveReconnectController);

import TeamFilterController from "./team_filter_controller";
application.register("team-filter", TeamFilterController);

import SegmentedDatetimeController from "./segmented_datetime_controller";
application.register("segmented-datetime", SegmentedDatetimeController);

import SplashController from "./splash_controller";
application.register("splash", SplashController);

import LogoutController from "./logout_controller";
application.register("logout", LogoutController);

import DisclosureMemoryController from "./disclosure_memory_controller";
application.register("disclosure-memory", DisclosureMemoryController);

import ConnectionFeedbackController from "./connection_feedback_controller";
application.register("connection-feedback", ConnectionFeedbackController);

import RefereeGameSelectController from "./referee_game_select_controller";
application.register("referee-game-select", RefereeGameSelectController);

import RefereeGameLockController from "./referee_game_lock_controller";
application.register("referee-game-lock", RefereeGameLockController);

import DocumentMaskController from "./document_mask_controller";
application.register("document-mask", DocumentMaskController);

import BottomNavController from "./bottom_nav_controller";
application.register("bottom-nav", BottomNavController);

import GameStatusGuardController from "./game_status_guard_controller";
application.register("game-status-guard", GameStatusGuardController);

import PwaInstallController from "./pwa_install_controller";
application.register("pwa-install", PwaInstallController);

import StaffRoleController from "./staff_role_controller";
application.register("staff-role", StaffRoleController);

import GroupScheduleController from "./group_schedule_controller";
application.register("group-schedule", GroupScheduleController);

import ModalController from "./modal_controller";
application.register("modal", ModalController);

import BulkSelectController from "./bulk_select_controller";
application.register("bulk-select", BulkSelectController);

import AutosaveFieldController from "./autosave_field_controller";
application.register("autosave-field", AutosaveFieldController);

import DialogOpenerController from "./dialog_opener_controller";
application.register("dialog-opener", DialogOpenerController);

import SyncValueController from "./sync_value_controller";
application.register("sync-value", SyncValueController);

import GameShareController from "./game_share_controller";
application.register("game-share", GameShareController);
